import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useCart } from 'lib/core/hooks'
import { useCheckout } from 'lib/modules/checkout'
import { placeOrder } from 'lib/core/data/quote/placeOrder'

export const CheckMo = () => {
  const dispatch = useDispatch()
  const { paymentMethod } = useCheckout()
  const { cartId, cart } = useCart()
  const { code, initialized } = paymentMethod

  useEffect(() => {
    if (!cartId || !code || !initialized) {
      return
    }

    dispatch(placeOrder(cartId, cart?.data, {
      method: code
    }))
  }, [
    cart?.data,
    initialized,
    cartId,
    code,
    dispatch
  ])

  return null
}
